import { Box, Typography } from "@mui/material";
import React from "react";
import { NotificationFullData } from "../../layout/UserNotification";
import useThemeStore from "../../services/store/useThemeStore";
import { wrapperStyles } from "./BookingStarted";
import { contentStyles } from "./BookingStarted";
import { titleStyles } from "./BookingStarted";
import { DateNTime } from "../../utils/dateTime";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const CoffeeCallCreated = ({
  notification,
}: {
  notification: NotificationFullData;
}) => {
  const { t } = useTranslation();
  const { darkMode } = useThemeStore();
  const navigate = useNavigate();
  return (
    <Box onClick={() => navigate("/coffee")} sx={wrapperStyles(darkMode)}>
      <Box sx={contentStyles}>
        <Typography sx={titleStyles(darkMode)}>
          {notification?.title ??
            t("coffee_call_requested", { ns: "notification" })}
        </Typography>
        <Typography
          sx={{ color: "#64748b", font: "var(--body-xs)", fontWeight: 400 }}
        >
          {notification.message}
        </Typography>
        {notification?.created_at && (
          <Typography
            sx={{
              font: "var(--semibold-xxs)",
              color: darkMode ? "#9ca3af" : "#64748b",
              fontWeight: 500,
            }}
          >
            {DateNTime.formatRelative(notification.created_at)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CoffeeCallCreated;
